import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Box,
  TextField,
  Button,
  Grid,
  Paper,
  Typography,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useGetList } from "../../../../hooks/useGetList";
import { useParams } from "react-router-dom";
import { usePost } from "../../../../hooks/usePost";
import ConvertUnitRelationForm from "./ConvertUnitRelationForm";
import { useSelector } from "react-redux";

const UnitConvertionForm = () => {
  const [showSuccessModal, setShowSuccessModal] = useState({
    show: false,
    message: "",
    formData: null,
  });
  const [confirmUnitRelation, setConfirmUnitRelation] = useState({
    show: false,
    data: null,
  });
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { id } = useParams();
  const { selectedBranch } = useSelector((state) => state.filterItemUnit);

  const { data, loading, refetch } = useGetList(
    `item-unit/options?relatedItem=${id}&relatedBranch=${selectedBranch}`,
  );
  const {
    postData,
    loading: postLoading,
    error,
  } = usePost(`unit-relation/get `);
  const { refresh } = useSelector((state) => state.refresh);

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      relatedBranch: selectedBranch,
    };
    const result = await postData(payload);

    if (result.success) {
      setShowSuccessModal((prev) => ({
        ...prev,
        show: true,
        message: result?.message || "Unit conversion saved successfully",
        formData: result?.data,
      }));
    }
  };

  const handleCloseModal = () => {
    setShowSuccessModal((prev) => ({ ...prev, show: false, message: "" }));
  };

  const handleConfirmModal = (data) => {
    setConfirmUnitRelation({ show: true, data });
    handleCloseModal();
  };

  useEffect(() => {
    refetch();
  }, [refresh]);

  return (
    <>
      <Paper elevation={3} sx={{ p: 3, mt: 5 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          Unit Conversion
        </Typography>

        <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={3}>
              <Controller
                name="relatedFromUnit"
                control={control}
                rules={{ required: "From unit is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="From Unit"
                    variant="outlined"
                    fullWidth
                    size="small"
                    disabled={postLoading}
                    error={!!errors.relatedFromUnit}
                    helperText={errors.relatedFromUnit?.message}
                  >
                    {!loading &&
                      data?.data?.map((option) => (
                        <MenuItem key={option._id} value={option._id}>
                          {option.name}
                        </MenuItem>
                      ))}
                  </TextField>
                )}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <Controller
                name="relatedToUnit"
                control={control}
                rules={{ required: "To unit is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="To Unit"
                    variant="outlined"
                    fullWidth
                    size="small"
                    disabled={postLoading}
                    error={!!errors.relatedToUnit}
                    helperText={errors.relatedToUnit?.message}
                  >
                    {!loading &&
                      data?.data?.map((option) => (
                        <MenuItem key={option._id} value={option._id}>
                          {option.name}
                        </MenuItem>
                      ))}
                  </TextField>
                )}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="medium"
                disabled={postLoading}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>

      {confirmUnitRelation.show && (
        <ConvertUnitRelationForm unitRelationData={confirmUnitRelation.data} />
      )}

      {/* Success Confirmation Modal */}
      <Dialog
        open={showSuccessModal.show}
        onClose={handleCloseModal}
        aria-labelledby="success-dialog-title"
        aria-describedby="success-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="success-dialog-title">
          Unit Conversion Successful
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {showSuccessModal?.formData?.isInverted
              ? ` conversion from ${showSuccessModal?.formData?.relatedFromUnit?.name}
            to ${showSuccessModal?.formData?.relatedToUnit?.name}. Are you going
            to proceed?`
              : showSuccessModal?.message}
          </Typography>

          {showSuccessModal.formData && (
            <Box sx={{ mt: 2, p: 2, bgcolor: "grey.50", borderRadius: 1 }}>
              <Typography variant="h6" gutterBottom>
                Relation Information:
              </Typography>
              <Typography variant="body2" color="text.secondary">
                From Unit : {showSuccessModal.formData.relatedFromUnit?.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                To Unit: {showSuccessModal.formData.relatedToUnit?.name}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseModal}
            color="secondary"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmModal.bind(null, showSuccessModal.formData)}
            color="primary"
            variant="contained"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UnitConvertionForm;
